import UserManager from '../../services/UserManager'

export default function syncAccount(currentAccount) {
  if (!UserManager.getUserFullName() && currentAccount.fullName) {
    UserManager.setUserFullName(currentAccount.fullName, false)
  }
}
